import { Trans, t } from '@lingui/macro';
import axios from 'axios';
import TriggerActionForm from 'components/forms/TriggerActionForm';
import Icon from 'components/ui/Icon';
import { LoaderContainer } from 'components/ui/Loader';
import { addMessage } from 'components/ui/Messages';
import React, { useCallback, useEffect, useState } from 'react';

function TriggerActionsList(props) {
  const { items, setEditAction, loadActions } = props;
  if (items.length < 1) return null;
  const removeItem = item => {
    axios.delete('/trigger-actions/' + item.pk)
      .then(() => {
        loadActions();
      })
      .catch(() => {
        addMessage('trigger-action-delete-' + item.pk, t`Unknown error`, t`Impossible to remove action`);
      });
    
  };

  return (
    <div>
      { items.map((item) => (
        <div key={item.pk} className="hstack gap-3 mb-1">
          { item.resource_name }
          <div className="actions ms-auto">
            
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => { setEditAction(item); }} >
              <Icon name="pencil" /> <Trans>Edit</Trans>
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary ms-2"
              onClick={() => { removeItem(item); }} >
              <Icon name="x-circle"/> <Trans>Remove</Trans>
            </button>
          </div>
        </div>
      )) }
    </div>
  );
}
function TriggerActions(props) {
  const { trigger } = props;
  const [editAction, setEditAction] = useState(null);
  const [addAction, setAddAction] = useState(null);
  const [actions, setActions] = useState(null);
 
  const loadActions = useCallback(() => {
    setActions(null);
    axios.get('/trigger-actions?trigger=' + trigger.pk)
      .then(res => {
        setActions(res.data);
      });
  }, [trigger.pk]);

  useEffect(() => {
    loadActions();
  }, [loadActions]);

  const onActionSave = (data) => {
    setEditAction(null);
    setAddAction(null);
    loadActions();
  };
  return (
    <>
      { actions === null ? (
        <LoaderContainer height="2" />
      ) : (
        <TriggerActionsList loadActions={loadActions} items={actions.items} setEditAction={setEditAction} />
      ) }
      <div></div>
      { editAction ? (
        <TriggerActionForm onSave={onActionSave} trigger={trigger} triggerAction={editAction} onCancel={() => setEditAction(null)} />
      ) : (
        addAction ? (
          <TriggerActionForm onSave={onActionSave} trigger={trigger} onCancel={() => setAddAction(false)} />
        ) : (
          <button type="button" className="btn btn-primary" onClick={() => { setAddAction(v => !v); }}>
            <Trans>Add an action</Trans>
          </button>
        )
      )}
    </>
  );
}

export default TriggerActions;
